module.exports = __webpack_public_path__ + "img/arrow-left.e60a493e.svg";